import { ThumbnailGenerationSourceMediaFormatEnum } from '@keepeek/commons';

var WHR_WIDTH = 1200;
var WHR_HEIGHT = 1200;
var UHD_WIDTH = 3840;
var UHD_HEIGHT = 3840;
var getCropUrl = function (_a) {
    var format = _a.format, outWidth = _a.outWidth, outHeight = _a.outHeight, src = _a.src, cropWidth = _a.cropWidth, cropHeight = _a.cropHeight, cropX = _a.cropX, cropY = _a.cropY, downloadFilename = _a.downloadFilename, addExtensionAtEnd = _a.addExtensionAtEnd;
    var params = new URLSearchParams();
    params.set("src", src);
    params.set("f", format);
    outWidth && params.set("w", outWidth.toString());
    outHeight && params.set("h", outHeight.toString());
    params.set("x", cropX.toString());
    params.set("y", cropY.toString());
    params.set("cw", cropWidth.toString());
    params.set("ch", cropHeight.toString());
    params.set("el", "true"); // enable enlarge image
    downloadFilename && params.set("fn", "".concat(downloadFilename, ".").concat(format.toLocaleLowerCase()));
    // Warning: this parameter must always be at the end of the URL
    // so that third-party tools which consume the generated image
    // (like Drupal which looks at the extension to generate the preview) work correctly!
    addExtensionAtEnd && params.set("extension", ".".concat(format.toLowerCase()));
    return "/crop?".concat(params.toString());
};
/**
 * Allows you to convert the crop dimensions and positions coming from the library to the dimensions and positions used by the Keepeek image service.
 * Indeed, it takes as parameters a crop size and position based either on the 4K image or the WHR of the element depending on the configuration.
 * Note that if the element size is less than 4K or WHR, it is based on the smallest size available.
 * All of this must therefore be taken into account in the conversion algorithm.
 * @param width crop width from crop library (based on image displayed)
 * @param height crop height from crop library (based on image displayed)
 * @param x crop X from crop library (based on image displayed)
 * @param y crop Y from crop library (based on image displayed)
 * @param element need element to get original width and height
 * @param previewWidth width of the image displayed in crop library
 * @param previewHeight height of the image displayed in crop library
 * @param serviceImageSourceMode configuration of service image source mode
 */
var adaptCropForImageService = function (_a) {
    var width = _a.width, height = _a.height, x = _a.x, y = _a.y, element = _a.element, previewWidth = _a.previewWidth, previewHeight = _a.previewHeight, serviceImageSourceMode = _a.serviceImageSourceMode;
    if (!element.width || !element.height) {
        throw new Error("can't adaptCropForImageService without element width or height");
    }
    var serviceImageSourceWidth;
    var serviceImageSourceHeight;
    switch (serviceImageSourceMode) {
        case ThumbnailGenerationSourceMediaFormatEnum.UHD:
            serviceImageSourceWidth = UHD_WIDTH;
            serviceImageSourceHeight = UHD_HEIGHT;
            break;
        case ThumbnailGenerationSourceMediaFormatEnum.WHR:
            serviceImageSourceWidth = WHR_WIDTH;
            serviceImageSourceHeight = WHR_HEIGHT;
            break;
        default:
            throw new Error("error during adaptCropForImageService conversion : ".concat(serviceImageSourceMode, " mode not implemented"));
    }
    var elementWidth = element.width;
    var elementHeight = element.height;
    // we must complete the final output size at the image service level in order to be able to correctly convert the data coming from the crop lib:
    // we start by determining the largest side:
    if (elementWidth > elementHeight) {
        // landscape
        // if the width of the element exceeds the width of the output configured on the image service: we adapt the width while maintaining the image ratio:
        if (elementWidth > serviceImageSourceWidth) {
            // we adapt the size proportionally:
            elementWidth = serviceImageSourceWidth;
            elementHeight = (elementHeight * elementWidth) / element.width;
        }
    }
    else {
        // portrait
        // if the height of the element exceeds the height of the output configured on the image service: we adapt the height while maintaining the image ratio:
        if (elementHeight > serviceImageSourceHeight) {
            elementHeight = serviceImageSourceHeight;
            elementWidth = (elementHeight * elementWidth) / element.height;
        }
    }
    return {
        width: Math.round((width * elementWidth) / previewWidth),
        height: Math.round((height * elementHeight) / previewHeight),
        x: Math.round((x * elementWidth) / previewWidth),
        y: Math.round((y * elementHeight) / previewHeight)
    };
};

export { adaptCropForImageService, getCropUrl };
//# sourceMappingURL=utils.js.map
